import React, { CSSProperties } from 'react';
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import styled from 'styled-components';

import { OptionsIcon } from '@/components/client/contracts';

export interface IDropdownItem {
  onClick?: (e: React.MouseEvent) => void;
  children: string | React.ReactElement;
  className?: string;
}

interface IProps {
  toggleAs?: React.ElementType;
  menuAs?: React.ElementType;
  children: React.ReactElement<IDropdownItem>[] | React.ReactElement<IDropdownItem>;
}

const Dropdown = ({ toggleAs, menuAs, children }: IProps): React.ReactElement => (
  <Container>
    <BootstrapDropdown>
      <BootstrapDropdown.Toggle as={toggleAs ?? CustomToggle}>
        <OptionsIcon />
      </BootstrapDropdown.Toggle>
      <BootstrapDropdown.Menu as={menuAs ?? CustomMenu}>{React.Children.toArray(children)}</BootstrapDropdown.Menu>
    </BootstrapDropdown>
  </Container>
);

const DropdownItem = ({ onClick, className, children }: IDropdownItem): React.ReactElement => {
  return (
    <BootstrapDropdown.Item onClick={onClick} className={`dropdown-item ${className ?? ''}`}>
      {children}
    </BootstrapDropdown.Item>
  );
};

Dropdown.Item = DropdownItem;

export { Dropdown };

const CustomMenu = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; style?: CSSProperties; className?: string; 'aria-labelledby'?: string }
>(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
  return (
    <div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
      {React.Children.toArray(children)}
    </div>
  );
});
CustomMenu.displayName = 'CustomMenu';

const CustomToggle = React.forwardRef<
  HTMLDivElement,
  { children?: React.ReactNode; onClick: (e: React.MouseEvent) => void }
>(({ children, onClick }, ref) => (
  <div
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));
CustomToggle.displayName = 'CustomToggle';

const Container = styled.div`
  .dropdown-menu {
    border-radius: 8px;
    border: 1px solid #dfdfdf;
    padding: 6px 0;
  }

  .dropdown-item {
    text-decoration: none;
    color: #374151;
    padding: 8px 12px;
    user-select: none;

    &:focus,
    &:hover {
      text-decoration: none;
      background-color: #f9fafb;
    }

    &:active {
      color: #0087dd !important;
    }
  }
`;
